<template>
<div>
    <articles
        :articles="articles"
        @update="updateArticles"
    />
</div>
</template>

<script>
    import { hasIn, isNil } from 'ramda';
    import Articles from '../components/Articles';

    const api = window.groovie.api;
    const baseUrl = api.base;
    let cart = baseUrl;
    if (hasIn('list', api) && !isNil(api.list)) {
        cart = `${cart}/${api.list}`;
    }

    export default {
        name: 'list',
        data() {
            return {
                articles: []
            };
        },
        methods: {
            updateArticles({ type, data }) {
                this[type](data);
            },
            delete(elementId = null) {
                this.$groovie
                    .delete(`${cart}/${elementId}`)
                    .then(({ data }) => {
                        this.articles = data.map(
                            ({ id, name, price, quantity, attributes }) => {
                                const { image } = attributes;

                                const article = {
                                    id,
                                    title: name,
                                    image,
                                    price,
                                    quantity,
                                    attributes
                                };
                                return article;
                            }
                        );

                        if (this.articles.length < 1) {
                            this.$emit('valid', false);
                        }
                    })
                    .catch(data => console.error('delete fail:', data));
            },
            update(article) {
                const id = article.id;
                this.$groovie
                    .put(`${cart}/${id}`, article)
                    .catch(data => console.error('update fail', data));
            },
            get() {
                this.$groovie
                    .get(cart)
                    .then(({ data }) => {
                        this.articles = data.map(
                            ({ id, name, price, quantity, attributes }) => {
                                const { image, icon } = attributes;

                                const article = {
                                    id,
                                    title: name,
                                    image,
                                    icon,
                                    price,
                                    quantity,
                                    attributes
                                };
                                this.$emit('valid', true);
                                return article;
                            }
                        );
                    })
                    .catch(data => console.error('fail get', data));
            },
            post() {
                this.$groovie
                    .post(cart, null)
                    .then(data => console.warn(data))
                    .catch(data => console.error(data));
            }
        },
        mounted() {
            this.get();
        },
        components: {
            Articles
        }
    };
</script>



// WEBPACK FOOTER //
// src/sections/List.vue